import { IUser } from '../../../../interfaces/entities';
import { Avatar } from './Avatar';

interface ChatProps {
  focus?: boolean;
  user: IUser;
  onClick: (user: IUser) => void;
}

const Chat: React.FC<ChatProps> = ({ focus, user, onClick }) => {
  const onClickFn = () => {
    if (onClick) {
      onClick(user);
    }
  };

  const containerClassName = `flex flex-row h-[70px] rounded-lg p-3 w-full border-[2px] border-solid hover:border-[#0C1FAA] transition-all cursor-pointer ${
    focus ? 'bg-[#0C1FAA] text-white border-[#0C1FAA]' : 'text-[#727272] border-[#E1E9EF] hover:bg-slate-50'
  }`;

  return (
    <div className={containerClassName} onClick={onClickFn}>
      <div className="relative">
        <Avatar url={user.photo} />

        {/* <div className="absolute bottom-0 right-0 bg-green-500 h-3 w-3 rounded-full"></div> */}
      </div>

      <div className="flex-1 ml-3">
        <div className="flex flex-row justify-between">
          <h6 className={`font-bold text-base ${focus ? '' : 'text-[#0C1FAA]'}`}>{user.first_name}</h6>
          {/* <span className="text-xs">3h30PM</span> */}
        </div>

        {/* <p className="text-xs">asdfas</p> */}
      </div>
    </div>
  );
};

export { Chat };
